import axios from "axios";
import { chinaControllerCode } from "../utils/constants";

const useConsentFragment = () => {
  const documentDomain = import.meta.env.VITE_DOMAIN;

  const processHtml = (stringData) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(stringData, "text/html");
    const csValues = {};
    try {
      csValues.emailTypes = doc.querySelector(
        ".truman-version-details input#truman-email-types"
      ).value;
    } catch (e) {
      csValues.emailTypes = "";
    }
    try {
      csValues.collectMethods = doc.querySelector(
        ".truman-version-details input#truman-collect-methods"
      ).value;
    } catch (error) {
      csValues.collectMethods = "";
    }
    try {
      csValues.requiredFields = doc.querySelector(
        ".truman-version-details input#truman-required-fields"
      ).value;
    } catch (error) {
      csValues.requiredFields = "";
    }
    try {
      csValues.requiredAnyFields = doc.querySelector(
        ".truman-version-details input#truman-required-any-of-fields"
      ).value;
    } catch (error) {
      csValues.requiredAnyFields = "";
    }
    try {
      csValues.requiredFormPreview = doc.querySelector(
        ".truman-version-details input#truman-required-remote-hcp-form-preview"
      ).value;
    } catch (error) {
      csValues.requiredFormPreview = "";
    }
    try {
      csValues.requiredValidationError = doc.querySelector(
        ".truman-version-details input#truman-required-fields-Error"
      ).value;
    } catch (error) {
      csValues.requiredValidationError = "";
    }
    try {
      csValues.version = doc.querySelector(
        ".truman-version-details input#truman-version-number"
      ).value;
    } catch (error) {
      csValues.version = "";
    }
    try {
      csValues.effectiveDate = doc.querySelector(
        ".truman-version-details input#truman-effective-date"
      ).value;
    } catch (error) {
      csValues.effectiveDate = "";
    }
    try {
      csValues.majorVersionNumber = doc.querySelector(
        ".truman-version-details input#truman-major-version-number"
      ).value;
    } catch (error) {
      csValues.majorVersionNumber = "";
    }
    try {
      csValues.majorChangeEffectiveDateTime = doc.querySelector(
        ".truman-version-details input#truman-major-change-effective-date-time"
      ).value;
    } catch (error) {
      csValues.majorChangeEffectiveDateTime = "";
    }
    try {
      csValues.commitHash = doc.querySelector(
        ".truman-version-details input#truman-commit-hash"
      ).value;
    } catch (error) {
      csValues.commitHash = "";
    }
    try {
      csValues.commitDateTime = doc.querySelector(
        ".truman-version-details input#truman-commit-datetime"
      ).value;
    } catch (error) {
      csValues.commitDateTime = "";
    }
    try {
      csValues.signatureField = doc.querySelector(
        ".truman-version-details input#truman-signature-field"
      ).value;
    } catch (error) {
      csValues.signatureField = "";
    }
    try {
      csValues.purposeList = doc.querySelector(
        ".truman-version-details input#truman-purpose-list"
      ).value;
    } catch (error) {
      csValues.purposeList = "";
    }
    try {
      csValues.requiredSenderNameInPayload = doc.querySelector(
        ".truman-version-details input#truman-required-sender-name-in-payload"
      ).value;
    } catch (error) {
      csValues.requiredSenderNameInPayload = "";
    }
    try {
      csValues.groupCheckboxChecked = doc.querySelector(
        ".truman-version-details input#truman-group-checkbox-checked"
      ).value;
    } catch (error) {
      csValues.groupCheckboxChecked = "";
    }

    return { ...csValues };
  };
  const getHtml = async (link) => {
    try {
      const res = await axios.get(link, {
        headers: {
          "Content-Type": "text/html",
        },
      });
      return processHtml(res?.data || "");
    } catch (error) {
      return { error: "No Consent Fragment Found" };
    }
  };
  //  Consent Collect process start
  const getVersionInfo = async (controller_code, customer_scope, language) => {
    if (controller_code) {
      let link = "";
      if (controller_code === chinaControllerCode)
        link = `${documentDomain}/${controller_code}/${customer_scope?.toLowerCase()}/${language}/cn_consent_fragment/index.html`;
      else
        link = `${documentDomain}/${controller_code}/${customer_scope}/${language}/cs/consent_fragment`;
      return getHtml(link);
    } else {
      throw new Error("Error fetching");
    }
  };
  const getDataPrivacyVersionsDatesInfo = async (
    controller_code,
    customer_scope,
    language
  ) => {
    if (controller_code) {
      const link = `${documentDomain}/${controller_code}/${customer_scope}/${language}/ps/data_privacy_fragment/`;
      return getHtml(link);
    } else {
      throw new Error("Error fetching");
    }
  };
  const getDraftEmailRemoteVersionsDatesInfo = async (
    controller_code,
    customer_scope,
    language
  ) => {
    if (controller_code) {
      const link = `${documentDomain}/${controller_code}/${customer_scope}/${language}/draft_email_remote/`;
      return getHtml(link);
    } else {
      throw new Error("Error fetching");
    }
  };
  const getConsentRemoteCollectVersionsDatesInfo = async (
    controller_code,
    customer_scope,
    language
  ) => {
    if (controller_code) {
      const link = `${documentDomain}/${controller_code}/${customer_scope}/${language}/cs/consent_remote_collect/`;
      return getHtml(link);
    } else {
      throw new Error("Error fetching");
    }
  };
  const getThankYouVersionsDatesInfo = async (
    controller_code,
    customer_scope,
    language
  ) => {
    if (controller_code) {
      const link = `${documentDomain}/${controller_code}/${customer_scope}/${language}/cs/consent_thankyou/`;
      return getHtml(link);
    } else {
      throw new Error("Error fetching");
    }
  };
  const getErrorVersionsDatesInfo = async (
    controller_code,
    customer_scope,
    language
  ) => {
    if (controller_code) {
      const link = `${documentDomain}/${controller_code}/${customer_scope}/${language}/cs/consent_error/`;
      return getHtml(link);
    } else {
      throw new Error("Error fetching");
    }
  };
  //  Consent Collect process End

  //  Unsubsribe   Document start

  const getUnsubCampaignVersionsDatesInfo = async (
    controller_code,
    customer_scope,
    language
  ) => {
    if (controller_code) {
      const link = `${documentDomain}/${controller_code}/${customer_scope}/${language}/uns/unsubscribe_campaign/`;
      return getHtml(link);
    } else {
      throw new Error("Error fetching");
    }
  };
  const getUnsubCommercialVersionsDatesInfo = async (
    controller_code,
    customer_scope,
    language
  ) => {
    if (controller_code) {
      const link = `${documentDomain}/${controller_code}/${customer_scope}/${language}/uns/unsubscribe_ae_commercial/`;
      return getHtml(link);
    } else {
      throw new Error("Error fetching");
    }
  };
  const getUnsubMedicalVersionsDatesInfo = async (
    controller_code,
    customer_scope,
    language
  ) => {
    if (controller_code) {
      const link = `${documentDomain}/${controller_code}/${customer_scope}/${language}/uns/unsubscribe_ae_medical/`;
      return getHtml(link);
    } else {
      throw new Error("Error fetching");
    }
  };
  const getUnsubThankYouVersionsDatesInfo = async (
    controller_code,
    customer_scope,
    language
  ) => {
    if (controller_code) {
      const link = `${documentDomain}/${controller_code}/${customer_scope}/${language}/uns/uns_error/`;
      return getHtml(link);
    } else {
      throw new Error("Error fetching");
    }
  };
  const getUnsubErrorVersionsDatesInfo = async (
    controller_code,
    customer_scope,
    language
  ) => {
    if (controller_code) {
      const link = `${documentDomain}/${controller_code}/${customer_scope}/${language}/uns/uns_error/`;
      return getHtml(link);
    } else {
      throw new Error("Error fetching");
    }
  };
  //  Unsubsribe   Document End
  //  E-mail Start
  const getDraftMailUpdateVersionsDatesInfo = async (
    controller_code,
    customer_scope,
    language
  ) => {
    if (controller_code) {
      const link = `${documentDomain}/${controller_code}/${customer_scope}/${language}/draft_email_update/`;
      return getHtml(link);
    } else {
      throw new Error("Error fetching");
    }
  };
  //  E-mail End
  //  Survery Document Start
  const getSurveyConfirmationVersionsDatesInfo = async (
    controller_code,
    customer_scope,
    language
  ) => {
    if (controller_code) {
      const link = `${documentDomain}/${controller_code}/${customer_scope}/${language}/cs/f_svy_confirmation/svy_confirmation/`;
      return getHtml(link);
    } else {
      throw new Error("Error fetching");
    }
  };
  const getSurveyThankYouVersionsDatesInfo = async (
    controller_code,
    customer_scope,
    language
  ) => {
    if (controller_code) {
      const link = `${documentDomain}/${controller_code}/${customer_scope}/${language}/cs/f_svy_confirmation/survey_thankyou/`;
      return getHtml(link);
    } else {
      throw new Error("Error fetching");
    }
  };
  const getSurveyErrorVersionsDatesInfo = async (
    controller_code,
    customer_scope,
    language
  ) => {
    if (controller_code) {
      const link = `${documentDomain}/${controller_code}/${customer_scope}/${language}/cs/f_svy_confirmation/survey_error/`;
      return getHtml(link);
    } else {
      throw new Error("Error fetching");
    }
  };
  //  Survery Document End
  return {
    getVersionInfo,
    getDataPrivacyVersionsDatesInfo,
    getDraftEmailRemoteVersionsDatesInfo,
    getConsentRemoteCollectVersionsDatesInfo,
    getThankYouVersionsDatesInfo,
    getErrorVersionsDatesInfo,
    getUnsubCampaignVersionsDatesInfo,
    getUnsubCommercialVersionsDatesInfo,
    getUnsubMedicalVersionsDatesInfo,
    getUnsubThankYouVersionsDatesInfo,
    getUnsubErrorVersionsDatesInfo,
    getDraftMailUpdateVersionsDatesInfo,
    getSurveyConfirmationVersionsDatesInfo,
    getSurveyThankYouVersionsDatesInfo,
    getSurveyErrorVersionsDatesInfo,
  };
};

export default useConsentFragment;
